const FileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8617 3.53203H6.48044C5.67419 3.53203 5.01794 4.18828 5.01794 4.99453V19.7297C5.01794 20.5359 5.67419 21.1922 6.48044 21.1922H17.5218C18.3281 21.1922 18.9844 20.5359 18.9844 19.7297V7.14375L14.8617 3.53203ZM17.3578 19.568H6.64216V5.15625H14.2523L17.3578 7.87968V19.568Z"
      fill="#2D3846"
    />
    <path
      d="M7.60547 9.87656C7.60547 10.3242 7.97109 10.6875 8.41641 10.6875H15.5812C16.0289 10.6875 16.3922 10.3219 16.3922 9.87656C16.3922 9.42891 16.0266 9.06562 15.5812 9.06562H8.41875C7.97109 9.06328 7.60547 9.42891 7.60547 9.87656ZM15.5812 14.0367H8.41875C7.97109 14.0367 7.60781 14.4023 7.60781 14.8477C7.60781 15.2953 7.97344 15.6586 8.41875 15.6586H15.5836C16.0313 15.6586 16.3945 15.293 16.3945 14.8477C16.3945 14.4023 16.0289 14.0367 15.5812 14.0367Z"
      fill="#2D3846"
    />
  </svg>
);

export default FileIcon;
